module.exports = __webpack_public_path__ + "img/ic_process_submittals.170b4348.png";